module.exports = __webpack_public_path__ + "img/entrance-bs.f3d662dd.png";